<template>
  <div>
    <div class="class-title" style="color:orange;">
      ————
      <span>热门路线</span>————
    </div>
    <div class="hotline-list">
      <ul >
        <li
          class="hotline-item"
          v-for="(item,index) in items"
          :key="index"
          @click="hotlineClick(item)"
        >
          <span>{{item.lineName}}</span>
        </li>
        <li class="clear"></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Col, Row } from 'vant'

export default {
  name: "hotLineList",
  components: {
    [Col.name]: Col,
    [Row.name]: Row
  },
  props: {
    items: Array
  },
  methods: {
    hotlineClick(item) {
      this.$emit("itemClick", item);
    }
  }
};
</script>


<style scoped lang="less">
.display{
  border:1px solid blue;

}

.class-title {
  line-height: 44px;
  text-align: center;
  color: #999;
  margin-top: 10px;
  margin: 0 25px;
}

.hotline-list {
  background-color: #fff;
  margin-bottom: 15px;
  padding: 5px 0px 0px 5px;
  border-radius: 2px;
  text-align: center;
  margin: 0 auto;
  width: 98%;
}

.hotline-item {
  font-size: 12px;
  line-height: 25px;
  text-align: center;
  background-color: #35c6da;
  color: #fff;
  padding: 6px 3px;
  margin-left: 2px;
  margin-top: 8px;
  float: left;
}

.clear {
  clear: both;
  margin-bottom: 10px;
}
</style>
